<template>
  <form @submit.prevent="handleSubmit">
    <div>
      <h1>TODO: Reset password {{ $route.params.token }}</h1>
      <router-link to="/" class="has-margin-top is-inline-block is-pulled-right">Tillbaka</router-link>
    </div>

    <input v-validate="'required'" name="password" type="password" placeholder="Password" ref="password" v-model="password">

    <input v-validate="'required|confirmed:password'" name="password_confirmation" type="password" placeholder="Password, Again" data-vv-as="password">

    <!-- ERRORS -->
    <div class="alert alert-danger" v-show="errors.any()">
      <div v-if="errors.has('password')">
        {{ errors.first('password') }}
      </div>
      <div v-if="errors.has('password_confirmation')">
        {{ errors.first('password_confirmation') }}
      </div>
    </div>
    <button type="submit" class="login-button" :disabled="isProcessing">
      <span v-if="!isProcessing">Submit</span>
      <span v-if="isProcessing"><i class="fal fa-spinner-third fa-spin"></i> Loggar in</span>
    </button>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
// import { setErrorsFromResponse } from '@/helpers'
export default {
  data () {
    return {
      isProcessing: false,
      password: null,
      submitted: false
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),

    clearErrors () {
      this.$validator.reset()
    },
    handleSubmit (e) {
      this.submitted = true
      let that = this

      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          that.resetPassword({ token: that.$route.params.token, password: that.password })
        }
      }).catch(function (error) {
        console.error(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Login/ResetPasswordPage.vue